import { formatCurrencyOptionalTwoDigit } from '../../../../formatters/formatCurrencyOptionalTwoDigit';
import { getCalculationLogic } from '../../../../constants/helpers/getCalculationLogic';
import { BorrowerLendingLimitTableType } from '../../../../constants/tables/BorrowerLendingLimitTableType';
import { formatTooltip } from '../../../../formatters/formatToolTip';

export const currencyCellItemRender = (e, bllTableType: BorrowerLendingLimitTableType) => {
    const targetId = `${bllTableType}_item_${e.rowIndex}_${e.columnIndex}`;
    const value = e.value;
    const formatted = value <= 0 ? '-' : formatCurrencyOptionalTwoDigit(value);
    const tooltipText = getCalculationLogic(bllTableType, e.column.dataField);

    return (
        <>
            <span
                data-tip
                data-for={targetId}
                style={{
                    float: 'right',
                    display: 'inline-block',
                }}
            >
                {formatted}
            </span>

            {tooltipText && formatTooltip(targetId, tooltipText)}
        </>
    );
};
